import { useState, useEffect } from "react";

import {
  Row,
  Col,
  Card,
  Button,
  Avatar,
  message,
  Form,
  Space,
  Input,
  Select,
  Modal,
  Checkbox,
} from "antd";

import BgProfile from "../assets/cms/profile-background-picture.jpg";

import axios from "axios";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Spinner from "../components/common/Spinner/Spinner";
import { v4 as uuidv4 } from "uuid";
import jwtDecode from "jwt-decode";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const possibleClients = [
  {
    label: "Mega Image",
    value: "Mega Image",
  },
  {
    label: "LSDV",
    value: "LSDV",
  },
  {
    label: "Sly Nutritia",
    value: "Sly Nutritia",
  },
  {
    label: "RER Ecologic",
    value: "RER Ecologic",
  },
  {
    label: "Grupul Tei",
    value: "Grupul Tei",
  },
  {
    label: "Orshar Logistics",
    value: "Orshar Logistics",
  },
  {
    label: "Aquila",
    value: "Aquila",
  },
  {
    label: "Quehenberger Logistics",
    value: "Quehenberger Logistics",
  },
  {
    label: "NEPI",
    value: "NEPI",
  },
  {
    label: "Professional Farmaline",
    value: "Professional Farmaline",
  },
  {
    label: "Pepco",
    value: "Pepco",
  },
  {
    label: "Electromagnetica",
    value: "Electromagnetica",
  },
  {
    label: "Other",
    value: "Other",
  },
];

const possibleActvityTypes = [
  {
    label: "Verificare agenti la schimbul de tura (L-V)",
  },
  {
    label: "Verificare agenti anterior armare (L-V)",
  },
  {
    label: "Verificare agenti la plecare (S-D)",
  },
  {
    label: "Verificare angajati MI la schimb de tura(L-V)",
  },
  {
    label: "Verificare angajati MI anterior armare (L-V)",
  },
  {
    label: "Verificare angajati MI la plecare (S-D)",
  },
  {
    label: "Verificari de noapte agenti /angajati MI",
  },
  {
    label: "Verificari de zi (L-V) cusete/vestiare/sala mese /zona vanzare",
  },
  {
    label: "Verificari de zi (S-D) cusete/vestiare/sala mese /zona vanzare",
  },
  {
    label: "Control Politie cu SO direct implicat",
  },
  {
    label: "Participare la oprire pers. suspecte de furt.",
  },
  {
    label: "Participare verificari/analizari prejudicii",
  },
  {
    label: "Raportare eveniment",
  },
  {
    label: "Patrulare/stationare echipaje mobile",
  },
  {
    label: "Solicitare telefonica sef magazin",
  },
  {
    label: "Solicitare telefonica agent securitate",
  },
  {
    label: "Solicitare telefonica CMV",
  },
  {
    label: "Preventie/activitate specifica in afara magazinului",
  },
  {
    label: "Servicii de test",
  },
  {
    label: "Control de zi",
  },
  {
    label: "Control de noapte",
  },
  {
    label: "Armare locatie",
  },
  {
    label: "Dezarmare locatie",
  },
  {
    label: "Verificare buton panica",
  },
  {
    label: "Verificare CCTV",
  },
  {
    label: "Verificare porti senzomatice",
  },
  {
    label: "Instruire personal",
  },
  {
    label: "Mentenanta semestiala",
  },
  {
    label: "Verificare coordonator",
  },
  {
    label: "Patrula",
  },
  {
    label: "Verificari angajati la schimb de tura",
  },
  {
    label: "Verificari angajati la inchidere/plecare",
  },
  {
    label: "Confirmare locatie",
  },
  {
    label: "Asistare la receptie marfa",
  },
];

function LocationProfile() {
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  // const [location, setLocation] = useState();

  const [messageApi, contextHolder] = message.useMessage();

  const [region, setRegion] = useState();
  const [client, setClient] = useState();
  const [locationName, setLocationName] = useState();
  const [locationCoordinates, setLocationCoordinates] = useState();
  const [locationAddress, setLocationAddress] = useState();
  const [costCenter, setCostCenter] = useState();
  const [email, setEmail] = useState();
  // const [email2, setEmail2] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [loadingClients, setLoadingClients] = useState(false);
  const [clients, setClients] = useState([]);

  const handleCheckboxChange = (checkedValues) => {
    setSelectedItems(checkedValues);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Location updated successfully",
    });
    history.push("/locations");
  };
  const successDelete = () => {
    messageApi.open({
      type: "success",
      content: "Location deleted successfully",
    });

    history.push("/locations");
  };
  const error = () => {
    messageApi.open({
      type: "error",
      content: "Something went wrong. Please try again later.",
    });
  };

  function checkIfEmail(str) {
    // Regular expression to check if string is email
    const regexExp =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

    return regexExp.test(str);
  }

  const getLocation = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `location/getLocation?locationId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);

      setClient(response.data.client);
      setLocationName(response.data.locationName);
      setLocationCoordinates(response.data.locationCoordinates);
      setLocationAddress(response.data.locationAddress);
      setCostCenter(response.data.costCenter);
      setEmail(response.data.email);
      setRegion(response.data.region);
      // setEmail2(response?.data?.email2);
      setSelectedItems(response?.data?.activityType);

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const updateLocation = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");

    if (
      region &&
      client &&
      locationName &&
      locationCoordinates &&
      locationAddress &&
      costCenter &&
      email
      // email2 &&
      // checkIfEmail(email) &&
      // checkIfEmail(email2)
    ) {
      try {
        console.log("TRUE");
        const response = await axios.put(
          process.env.REACT_APP_API_URL +
            `location/updateLocation?locationId=${id}`,
          {
            id: id,
            region: region,
            client: client,
            locationName: locationName,
            locationCoordinates: locationCoordinates,
            locationAddress: locationAddress,
            costCenter: costCenter,
            email: email,
            // email2: email2,
            activityType: selectedItems,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response);
        successDelete();
      } catch (e) {
        console.log(e);
        error();
      }
    } else {
      console.log("FALSE");
    }
  };

  const deleteLocation = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL +
          `location/deleteLocation?locationId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setIsModalOpen(false);
      successDelete();
      history.push("/locations");
    } catch (error) {
      setIsModalOpen(false);
      console.log(error);
      error();
    }
  };

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const handleChange2 = (item) => {
    setClient(item);
  };

  const getClients = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingClients(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "clients/getAllClients",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setClients(response.data);
      setLoadingClients(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    getLocation();
  }, []);

  return (
    <>
      {contextHolder}
      <div
        className="profile-nav-bg"
        style={{ backgroundImage: "url(" + BgProfile + ")" }}
      />

      {loading ? (
        <Spinner />
      ) : (
        <>
          <Card
            className="card-profile-head"
            bodyStyle={{ display: "none" }}
            title={
              <Row justify="space-between" align="middle" gutter={[24, 0]}>
                <Col span={24} md={12} className="col-info">
                  <Avatar.Group>
                    {/*<Avatar size={74} shape="square" src={profilavatar} />*/}

                    <div className="avatar-info">
                      <h4 className="font-semibold m-0">{locationName}</h4>
                      <p>{locationCoordinates}</p>
                    </div>
                  </Avatar.Group>
                </Col>
                <Col
                  span={24}
                  md={12}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <h1>{client}</h1>
                </Col>
              </Row>
            }
          />

          <Card
            bordered={false}
            className="header-solid mb-24"
            title={
              <>
                <h6 className="font-semibold">Edit Location</h6>
                <p>Edit location information below</p>
              </>
            }
          >
            <Row
              style={{
                marginLeft: "20px",
                marginRight: "20px",
              }}
            >
              <Form
                {...formItemLayout}
                form={form}
                name="register"
                onFinish={onFinish}
                initialValues={{
                  residence: ["zhejiang", "hangzhou", "xihu"],
                  prefix: "004",
                }}
                style={{
                  width: "80%",
                }}
                scrollToFirstError
              >
                <Form.Item
                  name="region"
                  label="Region"
                  tooltip="Please provide a region name"
                  initialValue={region}
                  rules={[
                    {
                      required: true,
                      message: "Please input the region!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="client"
                  label="Client"
                  tooltip="Please specify the client"
                  initialValue={client}
                  rules={[
                    {
                      required: client ? null : true,
                      message: "Please input the client!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Space
                    style={{
                      width: "100%",
                    }}
                    direction="vertical"
                  >
                    <Select
                      mode="single"
                      style={{
                        width: "100%",
                      }}
                      placeholder="Please select"
                      defaultValue={[client]}
                      onChange={handleChange2}
                      options={clients.map((client) => {
                        return {
                          label: client?.name,
                          value: client?.name,
                        };
                      })}
                    />
                  </Space>
                </Form.Item>

                <Form.Item
                  name="locationName"
                  label="Location Name"
                  tooltip="Please provide a location name"
                  initialValue={locationName}
                  rules={[
                    {
                      required: true,
                      message: "Please input the location name!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    value={locationName}
                    onChange={(e) => setLocationName(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="locationCoordinates"
                  label="Location Coordinates"
                  initialValue={locationCoordinates}
                  tooltip="Must be in the following format: 45.45118874636798, 28.04225951205401"
                  rules={[
                    {
                      required: true,
                      message: "Please input the location coordinates!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    value={locationCoordinates}
                    onChange={(e) => setLocationCoordinates(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="locationAddress"
                  label="Location Address"
                  initialValue={locationAddress}
                  rules={[
                    {
                      required: true,
                      message: "Please input the location address!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    value={locationAddress}
                    onChange={(e) => setLocationAddress(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="costCenter"
                  label="Cost Center"
                  initialValue={costCenter}
                  rules={[
                    {
                      required: true,
                      message: "Please input the location cost center!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    value={costCenter}
                    onChange={(e) => setCostCenter(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="emails"
                  label="Emails"
                  tooltip="Please input the client's valid email addresses separated by semicolumns `;` (Eg: 'premium-cms@gmail.com; tehnic@premium-cms.ro')"
                  initialValue={email}
                  rules={[
                    {
                      required: true,
                      message:
                        "Please input the client's valid email addresses separated by semicolumns `;` (Eg: 'premium-cms@gmail.com; tehnic@premium-cms.ro')",
                      whitespace: true,
                      // type: "email",
                    },
                  ]}
                >
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Item>

                {/*<Form.Item*/}
                {/*  name="email2"*/}
                {/*  label="Email 2"*/}
                {/*  initialValue={email2}*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: true,*/}
                {/*      message: "Please input the client valid email address!",*/}
                {/*      whitespace: true,*/}
                {/*      type: "email",*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Input*/}
                {/*    value={email2}*/}
                {/*    onChange={(e) => setEmail2(e.target.value)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                <Form.Item label="Activity Types">
                  <Checkbox.Group
                    onChange={handleCheckboxChange}
                    value={selectedItems}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                  >
                    {possibleActvityTypes.map((item) => (
                      <Checkbox
                        style={{ marginLeft: "6px" }}
                        key={item.label}
                        value={item.label}
                      >
                        {item.label}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>
                </Form.Item>

                <Form.Item {...tailFormItemLayout}>
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    type="secondary"
                    className="tag-primary"
                    htmlType="submit"
                    onClick={() => updateLocation()}
                  >
                    Update Location
                  </Button>
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    onClick={() => showModal()}
                    type="danger"
                  >
                    DELETE Location
                  </Button>
                  <Modal
                    title="Warning"
                    open={isModalOpen}
                    okText="Delete"
                    okType="danger"
                    onOk={deleteLocation}
                    onCancel={handleCancel}
                  >
                    <p>Are you sure you want do delete this location?</p>
                  </Modal>
                </Form.Item>
              </Form>
            </Row>
          </Card>
        </>
      )}
    </>
  );
}

export default LocationProfile;
